module.exports = __webpack_public_path__ + "static/media/vidya.34fc0c7e.jpg";